module.exports = __webpack_public_path__ + "static/img/rank_203.c942011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_203.png
// module id = bShU
// module chunks = 1